export const DELIMITER_NOTE = ", Telefonverifizierung-Notiz: "
export const DELIMITER_SMS = " [SMS-Validierung]: "
export const DELIMITER_USTID = ", USt-ID: "

export const APP_MODE_REGULAR = "regular"
export const APP_MODE_AGENCYSERVER_ADD_PROJECT = "agencyserver_add_project"
export const APP_MODE_OUTSOURCING = "outsourcing"
export const APP_MODE_AUTHENTICATED_ORDER = "authenticated_order"
export const APP_MODE_PRODUCT_CHANGE = "product_change"
export const APP_MODE_PRESET = "preset"
export const APP_MODE_ACCESSORY = "accessory"

export const PAYMENT_TYPE_SEPA = "SEPA"

/** Constants **/
export const INVOICE_TYPE_EMAIL = "email"
export const INVOICE_TYPE_POST = "post"
export const PAYMENT_TYPE_INVOICE = "INVOICE"
export const PROJECT_TYPE_CREATE = "PROJECT_TYPE_CREATE"
export const PROJECT_TYPE_SKIP = "PROJECT_TYPE_SKIP"

export const PRODUCT_SELECTION_CONSUMER = "SELECTION_CONSUMER";
export const PRODUCT_SELECTION_AGENCY = "SELECTION_AGENCY";
export const PRODUCT_SELECTION_AVMANAGER_UNLIMITED = "SELECTION_AVMANAGER_UNLIMITED";
export const PRODUCT_SELECTION_AVMANAGER_LITE = "SELECTION_AVMANAGER_LITE";
export const PRODUCT_SELECTION_PROSPACE= "SELECTION_PROSPACE";
export const PRODUCT_SELECTION_SPACESERVER = "SELECTION_SPACESERVER";

export const OUTSOURCING_CREATE_NEW = "OUTSOURCING_CREATE_NEW"
export const OUTSOURCING_ADDPROJECT = "OUTSOURCING_ADDPROJECT"

export const DOMAIN_TYPE_DEV = "DOMAIN_TYPE_DEV";
export const DOMAIN_TYPE_CUSTOM = "DOMAIN_TYPE_CUSTOM";

export const ARTICLE_TYPE_CMS = "cms";
export const ARTICLE_TYPE_SHOP = "shop";
export const ARTICLE_TYPE_DEV = "dev";
export const ARTICLE_TYPE_BASE = "base";

export const PROJECT_STATE_LIVE = "live";
export const PROJECT_STATE_DEV = "dev";

export const ARTICLE_CONFIGURATOR_MODE_CMS = "cms";
export const ARTICLE_CONFIGURATOR_MODE_SHOP = "shop";
export const ARTICLE_CONFIGURATOR_MODE_SHARED = "shared";
export const ARTICLE_CONFIGURATOR_MODE_CONSUMER = "consumer";
export const ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION = "consumer_selection";
export const ARTICLE_CONFIGURATOR_LAYOUT_WEBSITE = "website";
export const ARTICLE_CONFIGURATOR_LAYOUT_AGENCY = "agency";


export const SALUTATION_PREFIXES = {
  'Herr': 'Herr ',
  'Frau': 'Frau ',
  '' : '',
  'keine Angabe': '',
  'Divers': ''
};



/** WEBPACK FOOTER **
 ** ./src/constants/General.js
 **/